import { useMutation, useQueryClient } from '@tanstack/react-query';
import { reviewService } from '../../services';
import { FEED_QUERY_KEY } from './useFeed';
import { MY_PROFILE_QUERY_KEY } from './useProfile';

export function useCreateReview() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (reviewData) => reviewService.createReview(reviewData),
    onSuccess: () => {
      queryClient.invalidateQueries([FEED_QUERY_KEY]);
      queryClient.invalidateQueries([MY_PROFILE_QUERY_KEY, 'reviews']);
    },
  });
}
